import {useContext} from 'react';

import {
  AssignmentContext,
  statusTypes
} from 'client/AssignmentPracticeView/assignmentPracticeView.utils';

import {useAnnotationModeStore} from '../store/AnnotationModeStore';
import {useCanViewAnnotations} from './useCanViewAnnotations';

/**
 * Narrower than `useCanViewAnnotations`: a submitted assignment or a read-only surface
 * is readable but never editable, and other surfaces with no AssignmentContext stay open.
 */
export function useIsAnnotationModeAvailable(): boolean {
  const canViewAnnotations = useCanViewAnnotations();
  const isReadOnly = useAnnotationModeStore((state) => state.isReadOnly);
  const {status} = useContext(AssignmentContext);

  return canViewAnnotations && !isReadOnly && status !== statusTypes.submitted;
}
